import React from 'react'
import styled from 'styled-components' // S_ = Styled Component
import { Link } from '@reach/router'

const VenueMapSVG = (props) => (
  <StyledVenueMapSVG 
    id="Layer_1" 
    x="0px" y="0px"
	  viewBox="0 0 591.5 561.6"
    height={props.height} 
    aboveHeight={props.aboveHeight} 
    color={props.color}
  >
    <g id="Layer_2_1_">
      <Link to="/1">
        <rect x="101.3" y="305.7" class="st0" width="110.1" height="112.2" />
        <text transform="matrix(1 0 0 1 140.7787 355.5499)" class="st7 st5 st12">ROOM</text>
        <text transform="matrix(1 0 0 1 146.0787 383.5499)" class="st7 st5 st13">1</text>
      </Link>
      <rect x="71.9" y="0.3" class="st1" width="451.5" height="305.5"/>
      <rect x="472.6" y="305.9" class="st1" width="40.6" height="172.3"/>
      <Link to="/main">
        <rect x="101.3" y="0.3" class="st0" width="371.3" height="224.1" main />
        <g>
          <text transform="matrix(1 0 0 1 214.0938 118.45)" class="st7 st5 st8">Main auditorium</text>
        </g>
      </Link>
      <rect x="512.8" y="305.9" class="st0" width="78.4" height="112"/>
      <rect x="512.8" y="349.2" class="st2" width="29" height="68.6"/>
      <Link to="/2">
        <rect x="513.1" y="99.3" class="st0" width="78" height="125.1" two />
        <text transform="matrix(1 0 0 1 538.4951 156.1836)" class="st7 st5 st12">ROOM</text>
        <text transform="matrix(1 0 0 1 544.5951 184.1836)" class="st7 st5 st13">2</text>
      </Link>
      <Link to="/3">
        <rect x="513.1" y="0.3" class="st0" width="78" height="111.1" two />
        <text transform="matrix(1 0 0 1 538.4949 40.3734)" class="st7 st5 st12">ROOM</text>
        <text transform="matrix(1 0 0 1 543.7949 68.3734)" class="st7 st5 st13">3</text>
      </Link>
      <rect x="0.4" y="0.3" class="st2" width="71.6" height="22.1"/>
      <rect x="0.3" y="197.5" class="st2" width="71.6" height="220.4"/>
      <rect x="0.4" y="22.5" class="st0" width="71.6" height="175"/>
      <rect x="211.4" y="305.9" class="st0" width="261.2" height="112"/>
      <rect x="114.5" y="478.2" class="st0" width="457.2" height="58.7"/>
      <polyline class="st3" points="30.9,433.4 167.3,433.4 167.3,478.2 114.4,478.2 114.4,536.9 167.3,536.9 167.3,558.5 	"/>
      <polyline class="st3" points="200.1,558.8 200.1,536.9 571.5,536.9 571.5,478.2 513.2,478.2 513.2,433.4 591.1,433.4 591.1,417.9 	
        "/>
      <polyline class="st3" points="0.3,0.3 0.3,417.9 71.9,417.9 71.9,172.1 	"/>
      <line class="st3" x1="71.9" y1="10.2" x2="71.9" y2="0.3"/>
      <line class="st3" x1="71.9" y1="103.8" x2="71.9" y2="64.1"/>
      <line class="st3" x1="71.9" y1="158.2" x2="71.9" y2="116.5"/>
      <line class="st3" x1="0.4" y1="305.9" x2="71.9" y2="305.9"/>
      <line class="st3" x1="0.3" y1="219.7" x2="71.9" y2="219.7"/>
      <line class="st3" x1="0.4" y1="197.5" x2="71.9" y2="197.5"/>
      <polyline class="st3" points="0.4,22.5 71.9,22.5 71.9,49.1 	"/>
      <line class="st3" x1="0.3" y1="0.3" x2="523.5" y2="0.3"/>
      <rect x="0.3" y="422.5" class="st4" width="26.4" height="20.3"/>
      <rect x="194.6" y="433.4" class="st3" width="278.1" height="44.8"/>
      <polyline class="st3" points="200.1,540.7 237.4,540.7 286.4,546 	"/>
      <polyline class="st3" points="200.1,556 237.4,556 286.4,561.2 	"/>
      <line class="st3" x1="206.6" y1="540.7" x2="206.6" y2="556"/>
      <line class="st3" x1="213.1" y1="540.7" x2="213.1" y2="556"/>
      <line class="st3" x1="219.6" y1="540.7" x2="219.6" y2="556"/>
      <line class="st3" x1="226.1" y1="540.7" x2="226.1" y2="556"/>
      <line class="st3" x1="232.6" y1="540.7" x2="232.6" y2="556"/>
      <line class="st3" x1="238.9" y1="540.7" x2="238.9" y2="556"/>
      <line class="st3" x1="245.4" y1="541.5" x2="245.4" y2="556.7"/>
      <line class="st3" x1="251.9" y1="542.5" x2="251.9" y2="557.8"/>
      <line class="st3" x1="258.4" y1="543" x2="258.4" y2="558.2"/>
      <line class="st3" x1="264.9" y1="543.5" x2="264.9" y2="558.8"/>
      <line class="st3" x1="271.4" y1="544.2" x2="271.4" y2="559.5"/>
      <line class="st3" x1="277.9" y1="545.2" x2="277.9" y2="560.5"/>
      <line class="st3" x1="284.3" y1="546" x2="284.3" y2="561.2"/>
      <polyline class="st3" points="169.6,305.9 101.3,305.9 101.3,417.9 472.6,417.9 472.6,305.9 449.5,305.9 	"/>
      <line class="st3" x1="234.7" y1="305.9" x2="187.2" y2="305.9"/>
      <line class="st3" x1="301.4" y1="305.9" x2="252.1" y2="305.9"/>
      <line class="st3" x1="366.5" y1="305.9" x2="318.6" y2="305.9"/>
      <line class="st3" x1="431.8" y1="305.9" x2="383.8" y2="305.9"/>
      <line class="st3" x1="211.4" y1="305.9" x2="211.4" y2="417.9"/>
      <text transform="matrix(1 0 0 1 259.9225 261.5702)" class="st2 st5 st6">Exhibition</text>
      <text transform="matrix(1 0 0 1 252.7226 275.9702)" class="st2 st5 st6">and catering</text>
      <g>
        <text transform="matrix(1 0 0 1 311.1222 361.75)" class="st7 st5 st6">Exhibition</text>
        <text transform="matrix(1 0 0 1 303.9222 376.15)" class="st7 st5 st6">and catering</text>
      </g>
      
      <line class="st3" x1="234.7" y1="0.3" x2="187.2" y2="0.3"/>
      <line class="st3" x1="301.4" y1="0.3" x2="252.1" y2="0.3"/>
      <line class="st3" x1="366.5" y1="0.3" x2="318.6" y2="0.3"/>
      <line class="st3" x1="431.8" y1="0.3" x2="383.8" y2="0.3"/>
      <polyline class="st3" points="449.5,224.5 472.6,224.5 472.6,0.3 135.4,0.3 	"/>
      <polyline class="st3" points="169.6,224.5 101.3,224.5 101.3,0.3 169.6,0.3 	"/>
      <line class="st3" x1="234.7" y1="224.5" x2="187.2" y2="224.5"/>
      <line class="st3" x1="301.4" y1="224.5" x2="252.1" y2="224.5"/>
      <line class="st3" x1="366.5" y1="224.5" x2="318.6" y2="224.5"/>
      <line class="st3" x1="431.8" y1="224.5" x2="383.8" y2="224.5"/>
      <polyline class="st3" points="72,123.2 38.4,123.2 38.4,97.2 72,97.2 	"/>
      <line class="st3" x1="0.3" y1="110.5" x2="38.4" y2="110.5"/>
      <line class="st3" x1="513.1" y1="124.3" x2="513.1" y2="211.4"/>
      <line class="st3" x1="513.1" y1="106" x2="513.1" y2="115.6"/>
      <line class="st3" x1="513.1" y1="15.2" x2="513.1" y2="96.7"/>
      <polyline class="st3" points="513.1,220.9 513.1,224.5 591,224.5 591,0.3 513.1,0.3 513.1,4.1 	"/>
      <line class="st3" x1="512.8" y1="111.5" x2="591" y2="111.5"/>
      <rect x="523.5" y="224.5" class="st2" width="67.7" height="81.3"/>
      <polyline class="st3" points="523.5,234.5 523.5,224.5 591,224.5 591,305.9 523.5,305.9 523.5,294.5 	"/>
      <line class="st3" x1="523.5" y1="259.5" x2="523.5" y2="248.6"/>
      <line class="st3" x1="523.5" y1="281.2" x2="523.5" y2="271"/>
      <polyline class="st3" points="512.8,405.8 512.8,417.9 591,417.9 591,305.9 512.8,305.9 512.8,312.9 	"/>
      <line class="st3" x1="512.8" y1="324.5" x2="512.8" y2="393.9"/>
      <text transform="matrix(0.8872 0 0 1 300.509 558.6386)" class="st2 st9 st10">Entrance via escalator</text>
      <polygon class="st2" points="294.8,556.9 290.4,553.5 294.8,550.2 	"/>
    </g>
    <g id="Layer_1_1_">
      <g>
        <g>
          <path class="st7" d="M33.9,54.5c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4C34.7,55.8,33.9,55.2,33.9,54.5"/>
          <path class="st11" d="M34.2,56.2c-0.7,0.2-1,0.2-1.3,1.2c-0.1,0.3-1.6,4.2-1.8,5.6c-0.2,1.2,1,1.2,1.2,0.3
            c0.2-0.7,1.3-3.7,1.3-3.7l0.2,3.2c0,0-0.7,8.1-0.8,9.3c-0.1,1.2,1.3,1.2,1.5,0.2s0.8-7.6,0.8-7.6s0.7,6.6,0.9,7.6s1.6,1,1.5-0.2
            s-0.8-9.3-0.8-9.3l0.3-3.2c0,0,1.2,3,1.3,3.7c0.2,1,1.4,0.9,1.2-0.3c-0.3-1.4-1.7-5.3-1.8-5.6c-0.3-1.1-0.6-1.1-1.3-1.2
            C35.8,56.1,34.8,56.1,34.2,56.2"/>
          <polygon class="st11" points="32.4,67.2 38.2,67.2 36.9,62.2 33.7,62.2 			"/>
        </g>
        <g>
          <path class="st7" d="M33.9,145.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4
            C34.7,146.9,33.9,146.2,33.9,145.4"/>
          <path class="st7" d="M33.9,145.4L33.9,145.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4
            C34.7,146.9,33.9,146.2,33.9,145.4L33.9,145.4L33.9,145.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4
            C34.7,144,33.9,144.6,33.9,145.4L33.9,145.4z"/>
          <path class="st11" d="M34.2,147.2c-0.7,0.2-1.3,0.4-1.6,1.5c-0.1,0.3-1.6,4.2-1.8,5.6c-0.2,1.2,1.2,1.2,1.5,0.3
            c0.2-0.7,1.3-3.7,1.3-3.7l0.1,3.2c0,0-1.3,8.1-1.5,9.3c-0.1,1.2,1.6,1.2,1.8,0.2s1.4-7.6,1.4-7.6s1.3,6.6,1.4,7.6
            c0.2,1,1.9,1,1.8-0.2c-0.1-1.2-1.5-9.3-1.5-9.3l0.1-3.2c0,0,1.2,3,1.3,3.7c0.2,1,1.7,0.9,1.5-0.3c-0.3-1.4-1.7-5.3-1.8-5.6
            c-0.3-1.1-0.8-1.3-1.6-1.5C35.8,147,34.8,147,34.2,147.2"/>
        </g>
        <g>
          <path class="st7" d="M50.7,105.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1S50.7,105.7,50.7,105.1"/>
          <path class="st7" d="M50.7,105.1L50.7,105.1c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1S50.7,105.7,50.7,105.1
            L50.7,105.1L50.7,105.1c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1S50.7,104.5,50.7,105.1L50.7,105.1z"/>
          <path class="st7" d="M52.9,108.3h2.9c0.8,0,0.7,1,0,1h-2.7c0,0.2,0.1,0.3,0.1,0.4c0.1,0.4,0.2,0.4,0.5,0.4h2.4
            c0.6,0,0.8,0.2,0.9,0.6c0.1,0.4,0.9,2.8,1,3.1c0.1,0.3,0.4,0.2,0.4,0.2s0.1,0,0.7-0.2c0.6-0.2,0.8,0.9,0.3,1s-1.2,0.3-1.5,0.4
            c-0.4,0.1-0.5,0.1-0.6-0.3l-1.1-3.5c-0.1-0.3-0.2-0.4-0.7-0.4h-2.3c-0.6,0-0.8-0.2-0.9-0.5c-0.1-0.3-0.6-2.5-0.8-3.4
            c-0.2-1,0.9-1,1.1-0.2C52.7,107.3,52.8,107.8,52.9,108.3"/>
          <path class="st11" d="M51.7,109.1c0,0-2.1,0.8-2.1,3.4c0,2.5,1.9,3.8,3.8,3.8c1.6,0,2.9-1.1,3.4-1.9l-0.4-1.5
            c0,0-0.7,2.4-2.9,2.4s-2.8-1.6-2.8-2.7c0-1.3,0.5-2.1,1.3-2.4L51.7,109.1z"/>
        </g>
      </g>
      <text transform="matrix(1 0 0 1 303.0185 513.2008)" class="st7 st5 st6">Registration</text>
      
      
      
      <text transform="matrix(1 0 0 1 518.5487 332.3952)" class="st7 st5 st6">Cloakroom</text>
    </g>
  </StyledVenueMapSVG>

)

const StyledVenueMapSVG = styled.svg`
  fill: ${props => props.color}};
  height: ${props => props.height};
	transition: all 0.3s ease;
	width: 100%;
  @media (min-width: 350px) {
    height: ${props => props.aboveHeight}
  }
  .st0{fill:#64C2C8;}
	.st1{fill:#A9D0EB;}
	.st2{fill:#387192;}
	.st3{fill:none;stroke:#1D0E46;stroke-width:0.7;stroke-miterlimit:10;}
	.st4{fill:#1C6587;stroke:#1D0E46;stroke-width:0.7;stroke-miterlimit:10;}
	.st5{font-family:'FrutigerLTStd-Black';}
	.st6{font-size:12px;}
	.st7{fill:#FFFFFF;}
	.st8{font-size:16.5978px;}
	.st9{font-family:'FrutigerLTStd-Bold';}
	.st10{font-size:11px;}
	.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
	.st12{font-size:9px;}
	.st13{font-size:30px;}
  a:hover {
    .st0{fill: #2d9096;}
  }
`




export default VenueMapSVG
